<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div
            class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 d-flex align-items-center space-reuturn"
          >
            <v-btn class="btn-return ml-5" v-on:click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
          </div>
          <div
            class="col-xl-10 col-lg-10 col-md-9 col-sm-11 col-12 d-flex align-items-center"
          >
            <div class="row">
              <div
                class="p-0 mt-1 col-xl-1 col-lg-1 col-md-2 col-sm-2 col-12 check-text-center"
              >
                <div class="text-center">
                  <img
                    v-if="resident.photo_url"
                    :src="resident.photo_url"
                    class="photo-url"
                  />
                  <img
                    v-if="!resident.photo_url"
                    class="photo-url"
                    :src="require('../../assets/user.png')"
                  />
                </div>
              </div>
              <div class="col-xl-11 col-lg-11 col-md-10 col-sm-10 col-12">
                <div class="d-flex align-items-center residenttop-content">
                  <h4 class="mb-0 title-pages center-text">
                    {{ resident.name }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 pl-0">
            <div class="d-flex align-items-center">
              <button
                @click="handleStep('LANCAMENTOS')"
                :outlined="step != 'LANCAMENTOS'"
                :class="[
                  step == 'LANCAMENTOS' && 'btn-nav-menu',
                  step != 'LANCAMENTOS' && 'btn-nav-menu1',
                ]"
              >
                FATURAMENTOS
              </button>
              <div
                :class="[
                  step == 'LANCAMENTOS' && 'triangulo-para-direita',
                  step != 'LANCAMENTOS' && 'triangulo-none',
                ]"
              ></div>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="permission('read', 'resident_service')"
            >
              <button
                @click="handleStep('SERVICO')"
                :outlined="step != 'SERVICO'"
                :class="[
                  step == 'SERVICO' && 'btn-nav-menu',
                  step != 'SERVICO' && 'btn-nav-menu1',
                ]"
              >
                SERVIÇO
              </button>
              <div
                :class="[
                  step == 'SERVICO' && 'triangulo-para-direita',
                  step != 'SERVICO' && 'triangulo-none',
                ]"
              ></div>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="permission('read', 'resident_rest_home_sale_resident')"
            >
              <button
                @click="handleStep('CASA_DE_REPOUSO_VENDA_RESIDENTE')"
                :outlined="step != 'CASA_DE_REPOUSO_VENDA_RESIDENTE'"
                :class="[
                  step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE' && 'btn-nav-menu',
                  step != 'CASA_DE_REPOUSO_VENDA_RESIDENTE' && 'btn-nav-menu1',
                ]"
              >
                VENDA DA EMPRESA PARA O RESIDENTE
              </button>
              <div
                :class="[
                  step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE' &&
                    'triangulo-para-direita',
                  step != 'CASA_DE_REPOUSO_VENDA_RESIDENTE' && 'triangulo-none',
                ]"
              ></div>
            </div>
            <div
              v-if="permission('read', 'resident_hosting') && false"
              class="d-flex align-items-center"
            >
              <button
                @click="handleStep('HOSPEDAGEM')"
                :outlined="step != 'HOSPEDAGEM'"
                :class="[
                  step == 'HOSPEDAGEM' && 'btn-nav-menu',
                  step != 'HOSPEDAGEM' && 'btn-nav-menu1',
                ]"
              >
                HOSPEDAGEM
              </button>
              <div
                :class="[
                  step == 'HOSPEDAGEM' && 'triangulo-para-direita',
                  step != 'HOSPEDAGEM' && 'triangulo-none',
                ]"
              ></div>
            </div>
          </div>
          <div
            class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0"
          >
            <div
              v-if="step == 'LANCAMENTOS'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <menu-releases :resident="resident" />
            </div>
            <div
              v-if="step == 'SERVICO'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <menu-service :resident="resident" />
            </div>
            <div
              v-if="step == 'CASA_DE_REPOUSO_VENDA_RESIDENTE'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <menu-rest-home-sale-resident :resident="resident" />
            </div>
            <div
              v-if="step == 'HOSPEDAGEM'"
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            >
              <menu-hosting :resident="resident" />
            </div>
          </div>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar.vue";

import AuthBySessionExpired from "../Components/AuthBySessionExpired.vue";

import ErrorsMessages from "../Components/ErrorsMessages.vue";

import MenuReleases from "./resident/menu-releases.vue";

import MenuService from "./resident/menu-service.vue";

import MenuRestHomeSaleResident from "./resident/menu-rest-home-sale-resident.vue";

import MenuHosting from "./resident/menu-hosting.vue";

import api from "../../services/api";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "FamilyResident",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    MenuReleases,
    MenuService,
    MenuRestHomeSaleResident,
    MenuHosting,
  },

  data() {
    return {
      step: "LANCAMENTOS",

      resident_id: null,

      resident: { name: "", photo_url: null },

      loading: true,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    handleStep(step) {
      let newTab = {
        LANCAMENTOS: "releases",
        SERVICO: "service",
        CASA_DE_REPOUSO_VENDA_RESIDENTE: "rest-home-sale-resident",
        HOSPEDAGEM: "hosting",
      }[step];

      let { tab } = routes.history.current.query;

      if (tab != newTab) {
        routes.replace({ query: { tab: newTab } });
      }

      this.step = step;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      const { tab } = routes.history.current.query;

      if (tab) {
        this.step = {
          releases: "LANCAMENTOS",
          service: "SERVICO",
          "rest-home-sale-resident": "CASA_DE_REPOUSO_VENDA_RESIDENTE",
          hosting: "HOSPEDAGEM",
        }[tab];
      }

      this.resident_id = id;

      if (this.errors.length == 0) await this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { resident_id: id } = this;

        let params = { id };

        const response = await api.get("/rest-home/resident/name", {
          params,
        });

        const { resident, error } = response.data;

        if (error || !resident) {
          return routes.push({ name: "family" });
        }

        this.resident = resident;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToBack: () => routes.push({ name: "family" }),
  },
};
</script>

<style>
.photo-url {
  object-fit: contain;
}
</style>
